// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-HNgWO";
var _5 = "warning-22RBS";
var _6 = "warning__text-3F0KT";
var _7 = "warning__icon-2QtMj";
var _8 = "icon__text-10DiP";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "wrapper", _5 as "warning", _6 as "warning__text", _7 as "warning__icon", _8 as "icon__text" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "wrapper": _4, "warning": _5, "warning__text": _6, "warning__icon": _7, "icon__text": _8 }
